// extracted by mini-css-extract-plugin
export default {"mainInfo":"main-info_mainInfo__kFWGk","row":"main-info_row__iVFuW","label":"main-info_label__a8ILy","value":"main-info_value__wSiwW"};